import { Pagination } from '../../ui/pagination';

interface ListTablePaginationProps {
  /** 1-based current page. */
  page: number;
  /** Total page count — drives chevron-disabled state and the "X de Y" label. */
  totalPages: number;
  /** Currently selected page size. */
  rowsPerPage: number;
  /** Selectable page sizes for the dropdown. */
  rowsPerPageOptions: number[];
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  'data-testid'?: string;
}

/**
 * Shared pagination footer for list tables. Adapts the
 * `page`/`totalPages`/`rowsPerPage` shape used by the BFF queries to the
 * `page`/`total`/`pageSize` API of `@eureca/ui`'s `Pagination` primitive.
 *
 * Synthesising `total = totalPages * pageSize` is lossless for the
 * primitive's needs (it only re-derives `totalPages` from the pair),
 * so passing the displayed page count back round-trips exactly.
 */
export function ListTablePagination({
  page,
  totalPages,
  rowsPerPage,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange,
  ...rest
}: ListTablePaginationProps) {
  return (
    <Pagination
      page={page}
      pageSize={rowsPerPage}
      total={totalPages * rowsPerPage}
      pageSizeOptions={rowsPerPageOptions}
      onPageChange={onPageChange}
      onPageSizeChange={onRowsPerPageChange}
      data-testid={rest['data-testid']}
    />
  );
}
